import React from "react";

export function Stars({ n }) {
  const num = Math.min(5, Math.max(0, Number(n) || 5));
  return (
    <span>
      {Array.from({ length: num },   (_, i) => <span key={`f${i}`} style={{ color: "#F59E0B" }}>★</span>)}
      {Array.from({ length: 5-num }, (_, i) => <span key={`e${i}`} style={{ color: "#e2e8f0" }}>☆</span>)}
    </span>
  );
}

export function CatTag({ label }) {
  return (
    <span style={{ fontSize: 10, fontWeight: 600, padding: "2px 7px", borderRadius: 5, background: "#EEF2FF", color: "#3A3C7A" }}>
      {label}
    </span>
  );
}

export function SectionTitle({ children, style }) {
  return (
    <p style={{ fontSize: 10, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.08em", margin: 0, ...style }}>
      {children}
    </p>
  );
}
